import { css } from 'styled-components';

const secondaryScrollbar = css`
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.lightestGray};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #eaeaea;

    &:hover {
      background-color: #cbcbcb;
    }
  }
`;

export const Scrollbar = {
  secondary: secondaryScrollbar,
};
